
export default {
    name: "the-consent-toggle-item",
    data: () => ({
        showComponent: false,
    }),
    props: {
        title: {
            required: true,
            default: ''
        },
        icon: {
            required: false,
            default: ''
        },
        description: {},
        isPayment: {},
        isSelected: {}
    },
    methods: {
        selectMethod() {
            this.showComponent = !this.showComponent
            this.$emit('selectPaymentMethod')
        } 
    },
    computed: {
        arrowIcon() {
            return this.showComponent ? 'fxt-chevron-up' : 'fxt-chevron-down'
        }
    }
};
